module.exports = __webpack_public_path__ + "static/img/fling-nodata.f5068ff8.png";